import { FETCH_ME, RESET_ME } from "../../constants/action.constants";
import {
  getAccessToken,
  setUserDetails,
  setUserPermissions,
} from "../../services/browserStorage";
import { webApiCheck } from "../../services/commonMethods";
import { postDashboardWebApi } from "../../webApis/apiResource";

export const requestMe = (urlEndPoint, payload) => {
  return async (dispatch) => {
    const response = await postDashboardWebApi(
      getAccessToken(),
      urlEndPoint,
      payload
    );
    if (webApiCheck(response)) {
      setUserDetails(response.data.data);
      setUserPermissions(response.data.data.Role.permissions);
      dispatch(fetchMe(response.data.data));
    }
  };
};

const fetchMe = (data) => {
  return {
    type: FETCH_ME,
    payload: data,
  };
};

export const resetMe = () => {
  return {
    type: RESET_ME,
  };
};
